import React from 'react';
import { TrendingUp, TrendingDown, Minus, Grid } from 'lucide-react';

export default function MetricCard({
  title,
  value,
  subtext,
  change,
  changeType = 'up',
  icon: IconComponent,
}) {
  return (
    <div className="cyber-card" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {/* 4 Corner Brackets */}
      <span className="corner-tl" />
      <span className="corner-tr" />
      <span className="corner-bl" />
      <span className="corner-br" />

      {/* Top Header Row with Icon & Grid Indicator */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {IconComponent ? (
          <div
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              background: 'rgba(0, 255, 135, 0.12)',
              border: '1px solid rgba(0, 255, 135, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 10px rgba(0, 255, 135, 0.15)',
            }}
          >
            <IconComponent size={18} style={{ color: 'var(--neon-green)' }} />
          </div>
        ) : <div />}

        <Grid size={14} style={{ color: 'var(--text-muted)', opacity: 0.6 }} />
      </div>

      <span style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {title}
      </span>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
        <span style={{ fontSize: '1.85rem', fontWeight: 900, color: 'var(--text-primary)', letterSpacing: '-0.02em', lineHeight: 1, fontFamily: 'var(--font-mono)' }}>
          {value}
        </span>
        {change && (
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              padding: '2px 6px',
              borderRadius: '4px',
              fontSize: '0.68rem',
              fontWeight: 800,
              fontFamily: 'var(--font-mono)',
              background: changeType === 'up' ? 'rgba(0, 255, 135, 0.15)' : changeType === 'down' ? 'rgba(255, 51, 102, 0.15)' : 'rgba(255, 255, 255, 0.08)',
              color: changeType === 'up' ? 'var(--neon-green)' : changeType === 'down' ? 'var(--neon-rose)' : 'var(--text-secondary)',
              border: `1px solid ${changeType === 'up' ? 'rgba(0, 255, 135, 0.3)' : changeType === 'down' ? 'rgba(255, 51, 102, 0.3)' : 'var(--border-color)'}`,
            }}
          >
            {changeType === 'up' && <TrendingUp size={10} />}
            {changeType === 'down' && <TrendingDown size={10} />}
            {changeType === 'neutral' && <Minus size={10} />}
            <span>{change}</span>
          </div>
        )}
      </div>

      {subtext && (
        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
          {subtext}
        </div>
      )}
    </div>
  );
}
